import {APP_INITIALIZER, ApplicationConfig, Provider, provideZoneChangeDetection} from '@angular/core';
import {provideRouter, withComponentInputBinding, withViewTransitions} from '@angular/router';
import { routes } from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {KeycloakBearerInterceptor, KeycloakService} from "keycloak-angular";
import {provideAnimations} from "@angular/platform-browser/animations";
import {environment} from "../environments/environment";
import {BillHttpInterceptor} from "./isf/bills/bill.http.interceptor";
import {IsfFormHttpInterceptor} from "./isf/isf.form.http.interceptor";
import {provideToastr} from "ngx-toastr";
import {IsfViewHttpInterceptor} from "./isf/view/isf.view.http.interceptor";
import {NgIdleKeepaliveModule, provideNgIdleKeepalive} from "@ng-idle/keepalive";
import {NgIdleModule, provideNgIdle} from "@ng-idle/core";



export function initializeKeycloak(keycloak: KeycloakService) {
    
    return  () =>
        
        keycloak.init({
            config: {
                url: environment.keycloak,
                realm: environment.realm,
                clientId: environment.client,
            },
            initOptions: {
                onLoad: 'check-sso',
                checkLoginIframe:true,
                silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
            },
            loadUserProfileAtStartUp: false,
            enableBearerInterceptor: true,
            bearerPrefix: 'Bearer'
            // URLs excluded from Bearer token addition (empty by default)
            //bearerExcludedUrls: []
        });
}


// Provider for Keycloak Bearer Interceptor
const KeycloakBearerInterceptorProvider: Provider = {
    provide: HTTP_INTERCEPTORS,
    useClass: KeycloakBearerInterceptor,
    multi: true
};

// Provider for Keycloak Initialization
const KeycloakInitializerProvider: Provider = {
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    multi: true,
    deps: [KeycloakService]
}


const ISFBillFormProvider: Provider = {
    provide: HTTP_INTERCEPTORS,
    useClass: BillHttpInterceptor,
    multi:true
}


const ISFFormProvider: Provider = {
    provide: HTTP_INTERCEPTORS,
    useClass: IsfFormHttpInterceptor,
    multi:true
}

const ISFViewProvider: Provider = {
    provide: HTTP_INTERCEPTORS,
    useClass: IsfViewHttpInterceptor,
    multi:true
}

export const appConfig: ApplicationConfig = {
  providers: [
      provideZoneChangeDetection({ eventCoalescing: true }),
      //provideHttpClient(),
      KeycloakInitializerProvider, // Initializes Keycloak
      KeycloakBearerInterceptorProvider, // Provides Keycloak Bearer Interceptor
      KeycloakService, // Service for Keycloak
      ISFBillFormProvider,
      ISFFormProvider,
      ISFViewProvider,
      
      provideNgIdleKeepalive(),
      provideNgIdle(),
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations(),
      provideToastr(),
      provideRouter(routes,
          withViewTransitions(),
          withComponentInputBinding())
  ]
};
